import createEntityBundle from '~/src/Lib/createEntityBundle'
import { ControlSensorBasedEvent as schema } from '~/src/Store/Schemas'

const bundle = createEntityBundle({
  name: 'controlSensorBasedEvents',
  apiConfig: { schema, url: 'controlSensorBasedEvent' },
})

export default bundle
